import lozad from 'lozad'
import { header } from '../index/scripts/header'
import { ToggleItem, indicatorSlide, setBackgroundElement } from '../index/scripts/helper'
import Swiper, { Navigation, Pagination } from 'swiper'
import { home } from '../index/scripts/home'
import { tablePricing } from '../../js/tablePricing'
$(document).ready(function () {
	header.init();
	setBackgroundElement()
	swiperServiceNews()
	indicatorSlide()
	ToggleItem()
	swiperPortfolio();
	countElementServices();
	home.video()
	tablePricing();
})
function countElementServices () {
	const itemNumber = $('.section-service-detail.section-1 .wrap-item .item').length;
	const parent = $('.section-service-detail.section-1 .wrap-item');
	if (itemNumber == 5) {
		parent.addClass('five-columns')
	}
	if (itemNumber == 4) {
		parent.attr('style', "--columns:1;")
	}
}
function swiperPortfolio () {
	new Swiper('.section-service-detail.section-other-projects .swiper', {
		slidesPerView: 1,
		speed: 1000,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
		modules: [Navigation, Pagination],
		pagination: {
			el: ".section-service-detail.section-other-projects .swiper-pagination",
		},
		navigation: {
			nextEl: '.section-service-detail.section-other-projects .btn-next',
			prevEl: '.section-service-detail.section-other-projects .btn-prev',
		},
	})
}
function swiperServiceNews () {
	new Swiper('.section-service-detail.section-blog .swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		modules: [Navigation, Pagination],
		navigation: {
			nextEl: ".section-service-detail.section-blog .btn-next",
			prevEl: ".section-service-detail.section-blog .btn-prev",
		},
		pagination: {
			el: ".section-service-detail.section-blog .swiper-pagination",
		},
		breakpoints: {
			768: {
				slidesPerView: 2
			},
			1024: {
				slidesPerView: 4
			}
		},
	})
	new Swiper('.section-service-detail.section-news .swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		modules: [Navigation, Pagination],
		navigation: {
			nextEl: ".section-service-detail.section-news .btn-next",
			prevEl: ".section-service-detail.section-news .btn-prev",
		},
		pagination: {
			el: ".section-service-detail.section-news .swiper-pagination",
		},
		breakpoints: {
			768: {
				slidesPerView: 2
			},
			1024: {
				slidesPerView: 4
			}
		},
	})
	new Swiper('.section-service-detail.section-our .swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		modules: [Pagination],
		pagination: {
			el: ".section-service-detail.section-our .swiper-pagination",
		},
	})
}
/*==================== Lazyload JS ====================*/
const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()
